import type { StatusLinkAusgabe } from "../api/typen";
import { useToast } from "../kontext/ToastKontext";
import { kopiereText, linkFuerDieseAdresse } from "../lib/zwischenablage";
import { Hinweis, Knopf, Modal } from "./Basis";

/** Zeigt den Status-Link eines Kunden. Bleibt gültig, bis er gesperrt wird – anders als der
 * Einladungslink in BetriebSeite.tsx kann er hier also jederzeit erneut aufgerufen werden. */
export function StatusLinkModal({ ausgabe, schliessen }: { ausgabe: StatusLinkAusgabe; schliessen: () => void }) {
  const toast = useToast();

  const link = linkFuerDieseAdresse(ausgabe.link);

  async function kopieren() {
    if (await kopiereText(link)) toast.erfolg("Link kopiert");
    else toast.fehler(new Error("Kopieren nicht möglich – bitte den Link antippen, markieren und selbst kopieren."));
  }

  return (
    <Modal
      offen
      titel="Status-Link für den Kunden"
      beiSchliessen={schliessen}
      fuss={<Knopf variante="primaer" onClick={schliessen}>Fertig</Knopf>}
    >
      <div className="space-y-4 text-sm">
        <Hinweis art="info">
          Dieser Link bleibt gültig, bis er gesperrt wird – Sie können ihn hier jederzeit erneut
          aufrufen, falls der Kunde ihn verlegt.
        </Hinweis>
        <div>
          <label htmlFor="status-link" className="mb-1 block text-xs font-semibold">Link</label>
          <div className="flex gap-2">
            <input
              id="status-link"
              readOnly
              className="w-full rounded-lg border border-neutral-300 bg-neutral-50 px-3 py-2 font-mono text-xs"
              value={link}
              onFocus={(e) => e.target.select()}
            />
            <Knopf onClick={() => void kopieren()} data-autofokus>Kopieren</Knopf>
          </div>
        </div>
        <p className="text-xs text-neutral-500">
          Über diesen Link sieht der Kunde nur den groben Stand seiner Anmeldung, ohne Login. Kein
          Name, keine Adresse, keine sonstigen Daten.
        </p>
      </div>
    </Modal>
  );
}
